module.exports = __webpack_public_path__ + "img/orange.4bcadbeb.jpg";